const e = {
  enroll: {
    schema: {
      method: "post",
      url: "/{cid}/enroll",
      mediaType: "application/json"
    }
  },
  unenroll: {
    schema: {
      method: "delete",
      url: "/{cid}/{uid}"
    }
  }
};
export {
  e as cidService
};
